import { render, staticRenderFns } from "./ReorderDialog.vue?vue&type=template&id=2a558b33&scoped=true&"
import script from "./ReorderDialog.vue?vue&type=script&lang=js&"
export * from "./ReorderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a558b33",
  null
  
)

export default component.exports